import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import ButtonGroup from 'antd/es/button/button-group';
import React from 'react';

const Counter = (props) => {
    const { count, increment, decrement, size, theme = 'dark' } = props;

    return (
        <ButtonGroup size={size}>
            <Button
                className={`counter-btn counter-minus ${theme}`}
                type='primary'
                onClick={decrement}
                icon={<MinusOutlined />}
            />
            <Button
                icon={String(count)}
                className={`counter-btn count ${theme}`}
            />

            <Button
                className={`counter-btn counter-plus ${theme}`}
                type='primary'
                onClick={increment}
                icon={<PlusOutlined />}
            />
        </ButtonGroup>
    );
};

export default Counter;
